import React, { useState, useEffect } from "react";
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import { login, logout, clearSession } from "../actions/authentification";
import { WarnDialog } from '../components/shared';
import { LOGIN_INITIALISE_SUCCESS, LOGIN_SUCCESS, SET_MESSAGE, SET_APPLIED_PERMISSIONS, SET_USER_LOGIN } from "../actions/types";
import { Authentification, OIDCAuthentication } from "../services";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Box, Button, CircularProgress, Container, CssBaseline, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Link, Paper, TextField, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { LockOutline, EyeOutline, EyeOffOutline } from 'mdi-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import Logo from "../images/logo.png";
import LogoMicrosoft from "../images/login_microsoft2x2.png";
import ApproveRsaAuthentification from "../images/approve-animation-v3.gif";

const loadingIconKeyframes = `
/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
  `;
const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    buttonProgress: {
        color: '#2E94B9',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    buttonWrapper: {
        position: 'relative',
    },
}));
const validationSchema = yup.object({
    userId: yup
        .string('Enter your User Id')
        .required('User Id is required'),
    password: yup
        .string('Enter your password')
        //.min(8, 'Password should be of minimum 8 characters length')
        .required('Password is required'),
});
function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.ggcplc.com/">
                Global Green Chemicals
      </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
const LoginPage = (props) => {

    const { isAuthentificated, isLoggedIn, authnAttemptId, user } = useSelector(state => state.authentification);
    const errorMessage = useSelector((state) => state.message);

    //const [loading, setLoading] = useState(false);
    const [submitButton, setSubmitButton] = useState({ disabled: false, loading: false });
    const [authtId, setAuthtId] = useState({ id: null, loaded: false });
    const [showPassword, setShowPassword] = useState(false);
    const [aadAuthen, setAadAuthen] = useState(false);
    const [showLogin, setShowLogin] = useState(false);

    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [doubleFactor, setDoubleFactor] = useState({ "isAuthentificated": null, "authnAttemptId": null, "rsaInitialiseMessageId": null, "rsaAuthnAttemptId": null, "deviceName": "" });

    const showLocal = false;// new Date() < new Date('01-Jun-2023');

    const dispatch = useDispatch();
    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            userId: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => { handleSubmit(values) },
    });
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleSubmit = async values => {
        setSubmitButton({ disabled: true, loading: true });
        const { userId, password } = values;
        let p = Authentification.loginInitialise(userId, password);
        loginAction(p, values)
    }
    const handleDoubleAuthentification = async values => {
        dispatch({
            type: SET_MESSAGE,
            payload: "",
        });
        setSubmitButton({ disabled: false, loading: false });
        const { userId, password, authnAttemptId, rsaInitialiseMessageId, rsaAuthnAttemptId } = values;
        dispatch(login(userId, password, authnAttemptId, rsaInitialiseMessageId, rsaAuthnAttemptId))
            .then((response) => {
                if (response.loggedIn === false) {
                    dispatch(logout());
                    dispatch({
                        type: SET_MESSAGE,
                        payload: response.message,
                    });
                }
            })
            .catch(() => {
                setSubmitButton({ disabled: false, loading: false });
            });
    }
    const handleCancelDoubleAuthentification = () => {
        //const { userId, authnAttemptId } = values;
        Authentification.cancelDoubleAuthentification(authtId).then(
            (response) => { });
        dispatch(logout());
    }
    const loginAction = (promise, values) => {
        promise
            .then(
            (response) => {
                if (response.isAuthentificated === false && response.message) {
                    setWarnDialog({
                        isOpen: true,
                        title: 'Invalid Credentials',
                        subTitle: <><Box component="div">{response.message}</Box></>,
                    })
                    setSubmitButton({ disabled: false, loading: false });
                    return;
                }
                if (response.doubeFactor === false && response.user) {
                    dispatch({
                        type: LOGIN_SUCCESS,
                        payload: { user: response.user },
                    });
                    let flattened = response.privs.flat().filter(x => x !== null);
                    let final = [];
                    for (let i = 0; i < flattened.length; i++) {
                        final.push({ key: flattened[i].rolPriPageId, value: flattened[i].rolPriPrivileges })
                    }
                    let sorted = final.sort((a, b) => a.key - b.key);

                    //dispatch({
                    //    type: SET_TEST_PERMISSIONS,
                    //    payload: sorted,
                    //});
                    dispatch({
                        type: SET_APPLIED_PERMISSIONS,
                        payload: sorted,
                    });
                    dispatch({
                        type: SET_USER_LOGIN,
                        payload: response.user,
                    });
                    localStorage.setItem("user", JSON.stringify(response.user));
                    localStorage.setItem("permissions", JSON.stringify(sorted));
                    localStorage.setItem("oidc", JSON.stringify(response.oidc));
                }
                else {

                    let flattened = response.privs.flat().filter(x => x !== null);
                    let final = [];
                    for (let i = 0; i < flattened.length; i++) {
                        final.push({ key: flattened[i].rolPriPageId, value: flattened[i].rolPriPrivileges })
                    }
                    let sorted = final.sort((a, b) => a.key - b.key);
                    dispatch({
                        type: LOGIN_INITIALISE_SUCCESS,
                        payload: response,
                    });
                    //dispatch({
                    //    type: SET_TEST_PERMISSIONS,
                    //    payload: response.privs,
                    //});
                    dispatch({
                        type: SET_APPLIED_PERMISSIONS,
                        payload: sorted,
                    });
                    setDoubleFactor(response)
                    setAuthtId(response.authnAttemptId);
                    handleDoubleAuthentification({ ...values, authnAttemptId: response.authnAttemptId, rsaInitialiseMessageId: response.rsaInitialiseMessageId, rsaAuthnAttemptId: response.rsaAuthnAttemptId });
                }
            })
            .catch((err) => {
                if (err.toString().includes("status code 400")) {
                    setWarnDialog({
                        isOpen: true,
                        title: 'Account Disabled',
                        subTitle: <><Box component="div">This account has been disabled. If this is a mistake, please contact your administrator.</Box></>,
                    })
                    setSubmitButton({ disabled: false, loading: false });
                    return;
                }
                setSubmitButton({ disabled: false, loading: false });
            });
    }

    useEffect(() => {
        //check for no authen
        if (!aadAuthen) {
            setAadAuthen(true);
            const queryParams = new URLSearchParams(window.location.search)
            const key = queryParams.get("key")
            if (!isLoggedIn) {
                if (key) {
                    let p = OIDCAuthentication.getInfo(key);
                    loginAction(p)
                    const redirect = queryParams.get("redirect");
                    if (redirect) {
                        window.location.replace(redirect);
                    }
                } else {
                    dispatch(clearSession());
                    document.getElementById('loadingIcon').style.display = 'none';
                    //handleLoginAAD();
                }
            } else if (key) {
                window.location.replace(user?.defaultPage ?? '/');
            }
        }
    }, []);

    const handleLoginAAD = () => {
        document.getElementById('loadingIcon').style.display = 'block';
        OIDCAuthentication.getLogin().then(d => {
            if (d && d.redirect && d.uri) {
                window.location.replace(d.uri);
            } else {
                //setShowLogin(true);
                document.getElementById('loadingIcon').style.display = 'none';
            }
        })
    }

    return (
        <>
            <Box component="div" id="loadingIcon" style={{
                'background': 'rgb(0,0,0,0.5)',
                'top': '0',
                'left': '0',
                'width': '100%',
                'height': '100%',
                'position': 'absolute',
                'z-index': '999999'
            }}>
                <Box component="div" style={{
                    'position': 'absolute',
                    'left': '50%',
                    'top': '50%',
                    'transform': 'translate(-50 %, -50 %)',
                    'border': '16px solid #f3f3f3',
                    'border-radius': '50%',
                    'border-top': '16px solid #3498db',
                    'width': '120px',
                    'height': '120px',
                    '-webkit-animation': 'spin 2s linear infinite', /* Safari */
                    'animation': 'spin 2s linear infinite'
                    }}></Box>
            </Box>
            <style>{loadingIconKeyframes}</style>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                <Grid container spacing={3}
                    style={{ minHeight: '100vh', maxWidth: '100%' }}
                    alignItems="center"
                    justify="center">
                    <Grid item>
                        <Paper className={classes.paper}>
                            <Grid container spacing={3}
                                style={{ minHeight: 600, maxWidth: '100%' }}
                                alignItems="center"
                                justify="center">
                                <Grid item xs={12} md={6}>
                                    <img style={{ "margin": "50px auto", "display": "block", "width": "50%" }} src={Logo} alt='logo' />
                                    <Box py={3} />
                                    <Box component="div" style={{ 'line-height': '20px', 'background-color': 'antiquewhite' }}>
                                        {/*<Typography component="p" variant="body1" style={{ 'padding-bottom': '10px' }}>ระบบมีการเปลี่ยนแปลงการยืนยันตัวตนจาก RSA เป็น MFA ตั้งแต่วันที่ <span style={{ 'font-weight': '600' }}>31 พฤษภาคม 2566 เวลา 13:00</span> เป็นต้นไป ให้ผู้ใช้งานทุกท่านทำการติดตั้ง Microsoft Authenticator ที่มือถือ</Typography>*/}
                                        {/*<Typography component="p" variant="body1" style={{ 'font-weight': '600', 'text-align': 'center', 'padding-bottom': '10px' }}>** หากท่านพบปัญหาในการใช้งาน หรือติดตั้ง และ Sign-In สามารถสอบถาม หรือขอข้อมูลเพิ่มเติมได้ที่ <a style={{ 'color': 'darkgreen' }} href="tel:021403456">02-140-3456</a> หรือ ServiceDesk3456 <a style={{ 'color': 'crimson' }} href="mailto:servicedesk@pttdigital.com">servicedesk@pttdigital.com</a> **</Typography>*/}
                                        {/*<table style={{ width: '100%' }}>*/}
                                        {/*    <tr>*/}
                                        {/*        <td style={{ 'text-align': 'right' }}>Link VDO</td>*/}
                                        {/*        <td>: <a style={{ 'color': 'crimson' }} target="_blank" href="https://urldefense.com/v3/__https:/pttgcgroup.sharepoint.com/sites/TFE/Cybersecurity/SitePages/VDO-**H-sign-in-Microsoft-Authenticator.aspx__;4LiB4Liy4Lij!!BQcgKVYBOR0zXA!aQU5jbPk5XCbR73ZfjDIqA_0hGZi9bLfkst7_VaqkMIVB4Z0nubkcNfHc8TXq7JHvP2iT8PjDkilsCJV1IYgXVkI$">VDO การ sign-in Microsoft Authenticator (sharepoint.com)</a></td>*/}
                                        {/*    </tr>*/}
                                        {/*    <tr>*/}
                                        {/*        <td style={{ 'text-align': 'right' }}>Link คู่มือ</td>*/}
                                        {/*        <td>: <a style={{ 'color': 'crimson' }} target="_blank" href="https://urldefense.com/v3/__https:/pttgcgroup.sharepoint.com/sites/TFE/Cybersecurity/SitePages/EventPlanHome.aspx__;!!BQcgKVYBOR0zXA!aQU5jbPk5XCbR73ZfjDIqA_0hGZi9bLfkst7_VaqkMIVB4Z0nubkcNfHc8TXq7JHvP2iT8PjDkilsCJV1GzS5Em1$">Cybersecurity - Home (sharepoint.com)</a></td>*/}
                                        {/*    </tr>*/}
                                        {/*</table>*/}
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <>
                                        {isAuthentificated === false
                                        ?
                                        <Grid container spacing={3}
                                            style={{ borderLeft: "1px solid #c0c0c0", minHeight: 600, maxWidth: '100%' }}
                                            alignItems="center"
                                            justify="center">
                                            <Grid item xs={12} md={8}>
                                                <Typography component="p" variant="body1">{showLogin ? "Disabled Microsoft, Please use local account" : "Welcome back"}</Typography>
                                                <Typography component="h1" variant="h5">Login to your account</Typography>
                                                <Box py={4} />
                                                {showLogin || showLocal
                                                    ?
                                                    <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                                                        <TextField
                                                            size="small"
                                                            variant="outlined"
                                                            margin="normal"
                                                            fullWidth
                                                            id="userId"
                                                            label="User Id"
                                                            name="userId"
                                                            autoComplete="userId"
                                                            autoFocus
                                                            value={formik.values.userId}
                                                            onChange={formik.handleChange}
                                                            error={formik.touched.userId && Boolean(formik.errors.userId)}
                                                            helperText={formik.touched.userId && formik.errors.userId}
                                                        />
                                                        <FormControl error={formik.touched.password && Boolean(formik.errors.password)} className={clsx(classes.margin, classes.textField)} size="small" fullWidth variant="outlined">
                                                            <InputLabel htmlFor="password">Password</InputLabel>
                                                            <OutlinedInput
                                                                margin="dense"
                                                                name="password"
                                                                label="Password"
                                                                type={showPassword ? 'text' : 'password'}
                                                                id="password"
                                                                autoComplete="current-password"
                                                                value={formik.values.password}
                                                                onChange={formik.handleChange}
                                                                //helperText={formik.touched.password && formik.errors.password}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="toggle password visibility"
                                                                            onClick={handleClickShowPassword}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                        >
                                                                            {showPassword ? <EyeOutline /> : <EyeOffOutline />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                            />
                                                            <FormHelperText error={formik.touched.password && Boolean(formik.errors.password)} id="password-error">
                                                                {formik.touched.password && formik.errors.password}
                                                            </FormHelperText>
                                                        </FormControl>
                                                        <Box component="span" className={classes.buttonWrapper}>
                                                            <Button
                                                                disabled={submitButton.disabled}
                                                                type="submit"
                                                                fullWidth
                                                                variant="contained"
                                                                color="primary"
                                                            >Sign In</Button>
                                                            {submitButton.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                                        </Box>
                                                    </form>
                                                    :
                                                    <></>
                                                }
                                                {showLocal
                                                    ?
                                                    <Box component="div">
                                                        <Box py={1} />
                                                        <table style={{ 'width': '100%' }} >
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ 'width': '50%', 'vertical-align': 'middle' }} ><hr /></td>
                                                                    <td style={{ 'vertical-align': 'middle', 'white-space': 'nowrap', 'font-weight': 'bold' }} >Or</td>
                                                                    <td style={{ 'width': '50%', 'vertical-align': 'middle' }} ><hr /></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <Box py={1} />
                                                    </Box>
                                                    :
                                                    <></>
                                                }
                                                {!showLogin
                                                    ?
                                                    <Box component="span" className={classes.buttonWrapper}>
                                                        <Button variant='contained' fullWidth color='default' onClick={handleLoginAAD} style={{ minWidth: '250px' }}>
                                                            <img id="azureADlogo" src={LogoMicrosoft} alt="Microsoft" style={{ position: 'absolute', top: '11px', left: '13px', height: '20px', width: 'auto!important' }} />
                                                            <span id="azureButton" style={{ 'text-transform': 'none', 'font-weight': '600' }}>Sign in with Microsoft</span>
                                                        </Button>
                                                    </Box>
                                                    :
                                                    <></>
                                                }
                                            </Grid>
                                        </Grid>
                                        :
                                        <Grid container spacing={3}
                                            style={{ borderLeft: "1px solid #c0c0c0", minHeight: 600, maxWidth: '100%' }}
                                            alignItems="center"
                                            justify="center">
                                            <Grid item xs={12} md={8}>
                                                <Typography component="h1" variant="h5">Sign-In Request</Typography>
                                                <Typography component="p" variant="body2">Check "{doubleFactor.deviceName}" for a notification to continue authentification.</Typography>
                                                <img style={{ "margin": "40px auto", "display": "block", "width": "20%" }} src={ApproveRsaAuthentification} alt='approve' />
                                                <Button
                                                    type="submit"
                                                    fullWidth
                                                    variant="contained"
                                                    color="default"
                                                    onClick={handleCancelDoubleAuthentification}
                                                >Cancel</Button>
                                            </Grid>
                                        </Grid>
                                        }
                                    </>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <WarnDialog warnDialog={warnDialog} setWarnDialog={setWarnDialog} />
                </Grid>
                <Box mt={8}>
                    <Copyright />
                </Box>
                
            </Container>
        </>
    );
}

export default LoginPage;

